// extracted by mini-css-extract-plugin
module.exports = {"loadingImage":"Loading_loadingImage__3IDnD"};